import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import { Component } from '@vue/runtime-core'
import { createApp } from 'vue'
import LineClamp from '@/directives/lineClamp'
import moment from 'moment'
import Toast from '@/components/base/Toast.vue'

const lineClamp = LineClamp()
const app = createApp((App as unknown) as Component)

moment.locale('ko')
app.config.globalProperties.$moment = moment
app.directive(lineClamp.name, lineClamp)
app.component('Toast', Toast).use(store).use(router).mount('#app')
